import { http } from '@/utils'

//邀请分组列表
export const getMyGroupListApi = (data?: {
  page?: number
  page_size?: number
  account_type?: string
}): Promise<
  {
    account_type: string
    invent_code: string
    tag: string
  }[]
> => {
  return http.post('/api/agent/group_item', data)
}
